// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Jh24","validationTips":"StatementDescriptor_validationTips__Ltzyo"};